var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pipeline_layout"},[_c('div',{staticClass:"flex pb-50"},[_vm._t("filters")],2),_vm._v(" "),_c('div',{class:['pipeline_layout--content',
    {
      'is-board-style': _vm.isBoardStyle,
      'is-column-style': _vm.isColumnStyle,
    }]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }